import Link from 'next/link';
import { useTranslate } from '@tolgee/react';
import { SearchScope } from '@amf/shared/components/search/hooks/useAdvancedSearch';
import { SearchResultWithTeamFragment } from '@amf/shared/types/graphql';
import TeamDress from '@amf/shared/components/team/TeamDress';

type Props = {
  item: SearchResultWithTeamFragment;
  prefixes: { team: string };
};

function TeamResult({ item, prefixes }: Props) {
  const { t } = useTranslate();
  return (
    <Link href={`${prefixes.team}/${item.id}`} passHref>
      <a className='AdvancedSearch__resultItem'>
        {item.photoUrl ? (
          // eslint-disable-next-line @next/next/no-img-element
          <img src={item.photoUrl} alt={item.name} className='AdvancedSearch__resultItemImage' />
        ) : (
          <div className='AdvancedSearch__resultItemImage'>
            {/* @ts-ignore */}
            <TeamDress shorts={false} style={{ width: 48, height: 48 }} dress={{ ...item }} />
          </div>
        )}
        <div className='AdvancedSearch__resultItemContent'>
          <div className='AdvancedSearch__resultItemType'>
            {t(`search.scope.${SearchScope.TEAMS}.one`)}
          </div>
          <h3 className='AdvancedSearch__resultItemTitle'>{item.name}</h3>
          {item.description && (
            <p className='AdvancedSearch__resultItemDescription'>{item.description}</p>
          )}
        </div>
      </a>
    </Link>
  );
}

export default TeamResult;
